<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card v-if="matches.length>0">
        <v-tabs 
          v-model="tabIndex"
          centered>
          <v-tab 
            v-for="(sportMatches,key) in matches"
            :key="key">
            {{ $t(`sport.types.${sportMatches.config.name}.name`) }} ({{ sportMatches.matches.length }})
          </v-tab>
          <v-tab-item
            v-for="(sportMatches,key) in matches"
            :key="key" >
            <v-card flat>
              <v-card-text>
                <MatchesList 
                  :clubs="clubs"
                  :config="sportMatches.config"
                  :matches="sportMatches.matches" />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import MatchesList from '@/components/Dashboard/Views/Clubs/Templates/MatchesList'
const debug = require('debug')('OD::MatchesListContainer')

export default {
  name: 'MatchesListContainer',
  components: { MatchesList },
  props: {
    clubs: {
      type: Array,
      required: true,
    },
    matches: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tabIndex: null,
    }
  },
  computed: {},
  watch: {
    matches() {
      if (this.tabIndex > this.matches.length - 1) {
        this.tabIndex = 0
      }
    },
  },
  created() {
    debug('created matches', this.tabIndex, this.matches)
  },
  mounted() {
    debug('mounted matches', this.tabIndex, this.matches)
  },
  beforeDestroy() {},
  firestore: {},
  methods: {},
}
</script>

<style lang="scss">
</style>
